import './Header.scss';
import '@fortawesome/fontawesome-svg-core/styles.css';

import {
    Button,
    LocalizedLink,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { Sidenav } from './';
import {
    QuickCart,
    QuickCartIcon,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/QuickCart';
import React, { useEffect, useState } from 'react';
import { faBars, faUser } from '@fortawesome/free-solid-svg-icons';
import { graphql, useStaticQuery } from 'gatsby';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GatsbyImage } from 'gatsby-plugin-image';
import HeaderLogo from '../../images/droletLogoReverse.svg';
import HeaderLogo1 from '../../images/droletLogo.svg';
import SearchBar from '../search/SearchBar';
import SiteLocaleSelectionPopupMenu from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/SiteLocale/SiteLocaleSelectionPopupMenu';
import arrowIcon from '@progymedia/gatsby-theme-boutik-ecommerce/src/images/icons/Icon-Fleche.svg';
import iconShopping from '../../images/icons/icon-shopping.svg';
import { replaceWhiteSpace } from '../../utils';
import { useBoutikService } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/boutikService';
import { useCustomerAccount } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/customerAccount';
import { useLoginContext } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/login';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import { LoginDrawer } from '@sbi-international/boutik.gatsby.plugin.account';

export default function Header(props: {
    accessories: Map<any, any>;
    venting: Map<any, any>;
}) {
    const { accessories, venting } = props;
    const { isQuickLoginVisible, setQuickLoginVisible } = useLoginContext();
    const { currentLocale, navigateTranslated } = usePageLocalization();
    const [isSidenavOpen, setSidenavOpen] = useState(false);

    const [sidenavClassname, setSidenavClassname] = useState(
        'sidemenu sidenav-closing'
    );

    const data = useStaticQuery(
        graphql`
            query {
                appareils: allProductsJson(
                    filter: { code: { eq: "drolet_header-appareils" } }
                ) {
                    nodes {
                        code
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                        images
                        fields {
                            images {
                                childImageSharp {
                                    gatsbyImageData(width: 536)
                                }
                            }
                        }
                        attributes {
                            link {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                        }
                    }
                }
                tuyaux: allProductsJson(
                    filter: { code: { eq: "drolet_header-tuyaux" } }
                ) {
                    nodes {
                        code
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                        images
                        fields {
                            images {
                                childImageSharp {
                                    gatsbyImageData(width: 536)
                                }
                            }
                        }
                        attributes {
                            link {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                        }
                    }
                }
                accessoires: allProductsJson(
                    filter: { code: { eq: "drolet_header-accessoires" } }
                ) {
                    nodes {
                        code
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                        images
                        fields {
                            images {
                                childImageSharp {
                                    gatsbyImageData(width: 536)
                                }
                            }
                        }
                        attributes {
                            link {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                        }
                    }
                }
                service: allProductsJson(
                    filter: { code: { eq: "drolet_header-service" } }
                ) {
                    nodes {
                        code
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                        images
                        fields {
                            images {
                                childImageSharp {
                                    gatsbyImageData(width: 536)
                                }
                            }
                        }
                        attributes {
                            link {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                        }
                    }
                }
                alerte: allProductsJson(
                    filter: { code: { eq: "drolet_banniere-alerte" } }
                ) {
                    nodes {
                        code
                        title {
                            en_CA
                            en_US
                            fr_CA
                            markdown {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
        `
    );
    const isAlertBarDisplayed = data?.alerte?.nodes[0]?.title !== null;

    useEffect(() => {
        setSidenavClassname(
            isSidenavOpen
                ? 'sidemenu sidenav-window'
                : `sidemenu sidenav-closing`
        );
        const timer1 = setTimeout(
            () =>
                setSidenavClassname(
                    isSidenavOpen
                        ? 'sidemenu sidenav-window'
                        : `sidemenu sidenav-closing`
                ),
            1000
        );

        return () => {
            clearTimeout(timer1);
        };
    }, [isSidenavOpen]);

    return (
        <React.Fragment>
            <header className='header'>
                <LoginDrawer
                    isOpen={isQuickLoginVisible}
                    onClose={() => setQuickLoginVisible(false)}
                    onCreateAccountClick={
                        () =>
                            setTimeout(
                                () => navigateTranslated('/register/'),
                                300
                            ) // setTimeout pour l'animation
                    }
                    onForgotPasswordClick={
                        () =>
                            setTimeout(
                                () => navigateTranslated('/forgot-password/'),
                                300
                            ) // setTimeout pour l'animation
                    }
                />

                {/* hidden mobile sidenav menu */}
                <div className={sidenavClassname}>
                    <Sidenav
                        action={() => setSidenavOpen(false)}
                        accessories={accessories}
                        ventings={venting}
                    />
                </div>

                <AccountSection />
                <AlertBanner
                    bannerText={
                        data?.alerte?.nodes[0]?.title?.markdown?.[currentLocale]
                    }
                />
                <Nav data={data} />
            </header>
            <QuickCart />
        </React.Fragment>
    );

    function AlertBanner(props: { bannerText: string }) {
        const { bannerText } = props;

        if (props.bannerText)
            return (
                <div className='alert-banner'>
                    <span
                        className='banner-text'
                        dangerouslySetInnerHTML={{ __html: bannerText }}
                    ></span>
                </div>
            );
        else return null;
    }

    function AccountSection() {
        const { isAuthenticated } = useBoutikService();
        const { navigateTranslated } = usePageLocalization();
        const { currentUser } = useCustomerAccount();
        const { t } = useTranslation('layout');

        return (
            <div className='header-account-bg'>
                <div className='header-account'>
                    <div className='cart'>
                        <QuickCartIcon icon={iconShopping} />
                    </div>
                    <LocalizedLink to='/' className='header-logo'>
                        <img src={HeaderLogo1} alt='Drolet Logo' />
                    </LocalizedLink>
                    <div className='account'>
                        <FontAwesomeIcon icon={faUser} />
                        <span
                            onClick={() => {
                                if (isAuthenticated) {
                                    navigateTranslated('/account/my-account/');
                                } else {
                                    setQuickLoginVisible(true);
                                }
                            }}
                            className='account-title'
                        >
                            {isAuthenticated
                                ? currentUser?.firstname
                                : t('header.my-account')}
                        </span>
                    </div>
                    <SiteLocaleSelectionPopupMenu showCurrency={true} />
                    <LocalizedLink
                        className='retail'
                        label={t('header.where-to-buy')}
                        to={`/where-to-buy/`}
                    />
                    <FontAwesomeIcon
                        onClick={() => setSidenavOpen(true)}
                        className='hamburger-menu'
                        icon={faBars}
                    />
                </div>
            </div>
        );
    }

    function Nav(props: { data: any }) {
        const { data } = props;
        const { t } = useTranslation('layout');
        const { navigateTranslated, currentLocale } = usePageLocalization();

        const [navMenuOpen, setNavMenuOpen] = useState('none');
        const titles = {
            product: t('meta-titles.appliances'),
            venting: t('meta-titles.ventings'),
            accessory: t('meta-titles.accessories'),
            parts: t('meta-titles.parts'),
            service: t('meta-titles.support-service'),
        };

        const onMenuClick = (title: string) => {
            console.log(title);
            if (navMenuOpen == title) {
                setNavMenuOpen('none');
            } else if (title == t('meta-titles.parts')) {
                navigateTranslated('/archives/');
            } else {
                setNavMenuOpen(title);
            }
        };

        return (
            <div
                className='header-navmenu'
                onMouseLeave={() => setNavMenuOpen('none')}
            >
                <div className='header-nav'>
                    <LocalizedLink to='/' className='header-logo'>
                        <img src={HeaderLogo} alt='Drolet Logo' />
                    </LocalizedLink>

                    <ul className='nav-menus'>
                        {Object.values(titles).map((title, index: number) => {
                            return (
                                <li
                                    key={index}
                                    onClick={() => onMenuClick(title)}
                                >
                                    <span className='menu-text'>{title}</span>
                                </li>
                            );
                        })}
                    </ul>

                    <SearchBar />
                </div>

                {renderHeaderMenu(
                    navMenuOpen,
                    t,
                    titles.accessory,
                    titles,
                    data,
                    currentLocale
                )}
            </div>
        );
    }

    function renderHeaderMenu(
        title: string,
        t: any,
        accessoryTitle: string,
        titles: {
            product: string;
            venting: string;
            accessory: string;
            parts: string;
            service: string;
        },
        data: any,
        currentLocale: string
    ) {
        const headerMenuData = {
            [t('meta-titles.appliances')]: {
                'wood-stoves': {
                    title: 'wood-stoves',
                    link: '/wood-stoves/',
                },
                'appliance-pellet-stoves': {
                    title: 'appliance-pellet-stoves',
                    link: '/pellet-stoves/',
                },
                'camp-stove': {
                    title: 'camp-stove',
                    link: '/camp-stove/',
                },
                'wood-inserts': {
                    title: 'wood-inserts',
                    link: '/wood-inserts/',
                },
                'wood-furnaces': {
                    title: 'wood-furnaces',
                    link: '/wood-furnaces/',
                },
                'wood-cook-stoves': {
                    title: 'wood-cook-stoves',
                    link: '/cook-stoves/',
                },
                'outdoor-fireplaces': {
                    title: 'outdoor-fireplaces',
                    link: '/outdoor-fireplaces/',
                },
            },
            [t('meta-titles.ventings')]: Array.from(venting)[0][1]
                .sort((a: any, b: any) => a.label > b.label)
                .map((single: { label: string; category: string }) => {
                    const category = replaceWhiteSpace(
                        single.category.split('/')[3].toLowerCase(),
                        '-'
                    );
                    return {
                        title: single.label,
                        link: `/venting/${category}/`,
                    };
                }),
            [t('meta-titles.accessories')]: Array.from(accessories)[0][1]
                .sort((a: any, b: any) => a.label > b.label)
                .map((single: { label: string; slug: string }) => {
                    const slug = single.slug.split('/').join('/?type=');
                    return {
                        title: single.label,
                        link: `/${slug}`,
                    };
                }),
            [t('meta-titles.support-service')]: {
                'where-to-buy': {
                    title: 'where-to-buy',
                    link: '/where-to-buy/',
                },
                'find-retailer': {
                    title: 'find-retailer',
                    link: '/find-retailer/',
                },
                warranty: {
                    title: 'warranty',
                    link: '/warranty/stoves-inserts/',
                },
                contact: {
                    title: 'contact',
                    link: '/contact/',
                },
                about: {
                    title: 'about',
                    link: '/about/',
                },
                'gov-incentives': {
                    title: 'gov-incentives',
                    link: '/gov-incentives/',
                },
                manuals: {
                    title: 'manuals',
                    link: '/archives/',
                },
                videos: {
                    title: 'videos',
                    link: '/videos/',
                },
                faq: {
                    title: 'faq',
                    link: '/faq/wood-stoves/',
                },
                blog: {
                    title: 'blog',
                    link: '/blogArchives/',
                },
            },
        };

        return Object.entries(headerMenuData).map((menuData, index: number) => {
            let currentData;

            switch (title) {
                case titles.product: {
                    currentData = data.appareils.nodes[0];
                    break;
                }
                case titles.venting: {
                    currentData = data.tuyaux.nodes[0];
                    break;
                }
                case titles.accessory: {
                    currentData = data.accessoires.nodes[0];
                    break;
                }
                case titles.service: {
                    currentData = data.service.nodes[0];
                    break;
                }
                default: {
                    currentData = undefined;
                    break;
                }
            }

            if (menuData[0] === title) {
                return (
                    <HeaderMenu
                        key={index}
                        menus={menuData[1]}
                        t={t}
                        isLiteral={
                            menuData[0] === accessoryTitle ||
                            menuData[0] === titles?.venting
                        }
                        image={
                            currentData?.fields?.images?.[0]?.childImageSharp
                                .gatsbyImageData
                        }
                        link={
                            currentData?.attributes?.link?.values[0][
                                currentLocale
                            ]
                        }
                        label={currentData?.title[currentLocale].toUpperCase()}
                        isAlertBarDisplayed={isAlertBarDisplayed}
                    />
                );
            } else {
                return undefined;
            }
        });
    }

    function HeaderMenu(props: {
        menus: object;
        t: any;
        isLiteral?: boolean;
        image: any;
        link: string;
        label: string;
        isAlertBarDisplayed: boolean;
    }) {
        const { t, menus, isLiteral, image, link, label, isAlertBarDisplayed } =
            props;

        return (
            <div
                className={`header-menu ${isAlertBarDisplayed && 'show-alert'}`}
            >
                <div className='links'>
                    {Object.values(menus)?.map(
                        (
                            menu: { link: string; title: string },
                            index: number
                        ) => {
                            return isLiteral ? (
                                <LocalizedLink
                                    key={index}
                                    className='header-item'
                                    to={menu?.link}
                                    label={menu?.title?.toUpperCase()}
                                />
                            ) : (
                                <LocalizedLink
                                    key={index}
                                    className='header-item'
                                    to={menu?.link}
                                    label={t(
                                        `meta-titles.${menu?.title}`
                                    )?.toUpperCase()}
                                />
                            );
                        }
                    )}
                </div>

                <div />
                <div className='image-link'>
                    <div className='image'>
                        {image && <GatsbyImage image={image} alt='' />}

                        <Button
                            className='link'
                            link={link}
                            label={label.toUpperCase()}
                            iconRight={arrowIcon}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
